<div class="flex flex-col col-span-1">
  <ng-container *ngIf="mode === 'horizontal'">
    <label [tailLabel]="s" i18n="@@horizontal_align">Horizontal Align</label>
    <select #s="input" tailInput [(ngModel)]="value" class="appearance-none" [disabled]="disabled">
      <option *ngFor="let option of horizontalLabels" [value]="option">{{getHorizontalAlignLabel(option)}}</option>
    </select>
  </ng-container>
  <ng-container *ngIf="mode === 'vertical'">
    <label [tailLabel]="s" i18n="@@vertical_align">Vertical Align</label>
    <select #s="input" tailInput [(ngModel)]="value" class="appearance-none" [disabled]="disabled">
      <option *ngFor="let option of verticalLabels" [value]="option">{{getVerticalAlignLabel(option)}}</option>
    </select>
  </ng-container>
</div>
